import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        borderRadius: 'none',
        display: 'inline-flex',
        maxW: '100%',
        outlineWidth: 0,
        textStyle: 'body-medium',
        fontWeight: 'bold',
        alignItems: 'center',
        _focusVisible: {
            border: remCalc(3),
            borderStyle: 'solid',
            borderColor: 'button.border.accessibility-blue-dark',
            outline: 'unset',
            boxShadow: 'unset',
        },
        _disabled: {
            opacity: 1,
        },
    },
    variants: {
        primary: {
            padding: `${remCalc(18)} ${remCalc(24)}`,
            maxHeight: remCalc(40),
            bg: 'button.background.primary-default',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            color: 'button.text.primary-default',
            _hover: {
                bg: 'button.background.primary-hover',
            },
            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-light',
                outline: 'unset',
                boxShadow: 'unset',
            },
            _disabled: {
                bg: 'button.background.primary-disabled',
                color: 'button.text.primary-disabled',
                _hover: {
                    bg: 'button.background.primary-disabled !important',
                    color: 'button.text.primary-disabled',
                },
            },
            _active: {
                bg: 'button.background.primary-default', // when a button is clicked, we use default colors
                color: 'button.text.primary-default',
            },
            _pressed: {
                bg: 'button.background.primary-pressed',
                color: 'button.text.primary-pressed',
            },
        },
        'primary-small': {
            textStyle: 'body-xsmall',
            padding: `${remCalc(12)} ${remCalc(16)}`,
            maxHeight: remCalc(33),
            bg: 'button.background.primary-default',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            color: 'button.text.primary-default',
            _hover: {
                bg: 'button.background.primary-hover',
            },
            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
                boxShadow: 'unset',
            },
            _disabled: {
                bg: 'button.background.primary-disabled',
                color: 'button.text.primary-disabled',
                _hover: {
                    bg: 'button.background.primary-disabled !important',
                    color: 'button.text.primary-disabled',
                },
            },
            _active: {
                bg: 'button.background.primary-default', // when a button is clicked, we use default colors
                color: 'button.text.primary-default',
            },
            _pressed: {
                bg: 'button.background.primary-pressed',
                color: 'button.text.primary-pressed',
            },
        },
        secondary: {
            padding: `${remCalc(18)} ${remCalc(24)}`,
            maxHeight: remCalc(40),
            bg: 'button.background.secondary-default',
            color: 'button.text.secondary-default',
            border: remCalc(1),
            borderColor: 'button.border.secondary-default',
            borderStyle: 'solid',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            _hover: {
                border: 'none',
                color: 'button.text.secondary-hover',
                bg: 'button.background.primary-default',
            },
            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
                boxShadow: 'unset',
            },
            _active: {
                bg: 'button.background.secondary-focused',
                color: 'button.text.secondary-default',
                border: remCalc(1),
                borderColor: 'button.border.secondary-default',
                borderStyle: 'solid',
            },
            _disabled: {
                color: 'button.text.secondary-disabled',
                bg: 'button.background.secondary-disabled',
                borderColor: 'button.border.secondary-disabled',
                _hover: {
                    bg: 'button.background.secondary-disabled',
                    color: 'button.text.secondary-disabled',
                    border: remCalc(1),
                    borderColor: 'button.border.secondary-disabled',
                    borderStyle: 'solid',
                },
            },
            _pressed: {
                bg: 'button.background.secondary-pressed',
                color: 'button.text.secondary-pressed',
                borderColor: 'button.border.secondary-pressed',
            },
        },
        'secondary-small': {
            textStyle: 'body-xsmall',
            padding: `${remCalc(12)} ${remCalc(16)}`,
            maxHeight: remCalc(33),
            bg: 'button.background.secondary-default',
            color: 'button.text.secondary-default',
            border: remCalc(1),
            borderColor: 'button.border.secondary-default',
            borderStyle: 'solid',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            _hover: {
                border: 'none',
                color: 'button.text.secondary-hover',
                bg: 'button.background.secondary-hover',
            },
            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
                boxShadow: 'unset',
            },
            _active: {
                bg: 'button.background.secondary-default',
                color: 'button.text.secondary-default',
            },
            _disabled: {
                color: 'button.text.secondary-disabled',
                bg: 'button.background.secondary-disabled',
                borderColor: 'button.border.secondary-disabled',
                _hover: {
                    bg: 'button.background.secondary-disabled',
                    color: 'button.text.secondary-disabled',
                    border: remCalc(1),
                    borderColor: 'button.border.secondary-disabled',
                    borderStyle: 'solid',
                },
            },
            _pressed: {
                bg: 'button.background.secondary-pressed',
                color: 'button.text.secondary-pressed',
                borderColor: 'button.border.secondary-pressed',
            },
        },
        'icon-button': {
            bg: 'button.background.icon-default',
            color: 'button.text.icon-default',
            _hover: {color: 'button.text.icon-hover'},
            _disabled: {color: 'button.text.icon-disabled'},
            _pressed: {color: 'button.text.icon-pressed'},
        },
        'text-button': {
            bg: 'button.background.text-default',
            color: 'button.text.text-default',
            textDecoration: 'underline',
            _disabled: {color: 'button.text.text-disabled'},
            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
                boxShadow: 'unset',
            },
        },
        'primary-pressed': {
            whiteSpace: 'normal',
            padding: `${remCalc(18)} ${remCalc(24)}`,
            maxHeight: remCalc(40),
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            bg: 'button.background.inverse-primary-pressed',
            color: 'button.text.inverse-primary-pressed',
            borderColor: 'button.border.secondary-pressed',
            _hover: {
                bg: 'button.background.inverse-primary-pressed',
                color: 'button.text.inverse-primary-pressed',
                borderColor: 'button.border.secondary-pressed',
                _disabled: {
                    bg: 'button.background.inverse-primary-pressed',
                    color: 'button.text.inverse-primary-pressed',
                    borderColor: 'button.border.secondary-pressed',
                },
            },
        },
        'primary-pressed-small': {
            whiteSpace: 'normal',
            textStyle: 'body-xsmall',
            padding: `${remCalc(12)} ${remCalc(16)}`,
            maxHeight: remCalc(33),
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            bg: 'button.background.inverse-primary-pressed',
            color: 'button.text.inverse-primary-pressed',
            borderColor: 'button.border.secondary-pressed',
        },
        //* Inverse styles
        'inverse-primary': {
            padding: `${remCalc(18)} ${remCalc(24)}`,
            maxHeight: remCalc(40),
            borderRadius: [
                'button.radius.inverse-primary-default.base',
                'button.radius.inverse-primary-default.sm',
                'button.radius.inverse-primary-default.md',
                'button.radius.inverse-primary-default.lg',
            ],
            bg: 'button.background.inverse-primary-default',
            color: 'button.text.inverse-primary-default',
            _hover: {
                bg: 'button.background.inverse-primary-hover',
                color: 'button.text.inverse-primary-hover',
            },
            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
                boxShadow: 'unset',
            },
            _active: {
                bg: 'button.background.inverse-primary-default',
                color: 'button.text.inverse-primary-default',
            },
            _disabled: {
                color: 'button.text.inverse-primary-disabled',
                bg: 'button.background.inverse-primary-disabled',
                _hover: {
                    bg: 'button.background.inverse-primary-disabled !important',
                    color: 'button.text.inverse-primary-disabled',
                },
            },
            _pressed: {
                color: 'button.text.inverse-primary-pressed',
                bg: 'button.background.inverse-primary-pressed',
            },
        },
        'inverse-secondary': {
            padding: `${remCalc(18)} ${remCalc(24)}`,
            maxHeight: remCalc(40),
            borderRadius: [
                'button.radius.inverse-secondary-default.base',
                'button.radius.inverse-secondary-default.sm',
                'button.radius.inverse-secondary-default.md',
                'button.radius.inverse-secondary-default.lg',
            ],
            bg: 'button.background.inverse-secondary-default',
            color: 'button.text.inverse-secondary-default',
            border: remCalc(2),
            borderColor: 'button.border.inverse-secondary-default',
            borderStyle: 'solid',
            _hover: {
                border: 'none',
                color: 'button.text.inverse-secondary-hover',
                bg: 'button.background.inverse-secondary-hover',
            },
            _focus: {
                borderColor: 'button.border.inverse-secondary-focused',
                color: 'button.text.inverse-secondary-focused',
                bg: 'button.background.inverse-secondary-focused',
            },
            _active: {
                bg: 'button.background.inverse-secondary-default',
                color: 'button.text.inverse-secondary-default',
                border: remCalc(2),
                borderColor: 'button.border.inverse-secondary-default',
                borderStyle: 'solid',
            },
            _disabled: {
                bg: 'button.background.inverse-secondary-disabled',
                borderColor: 'button.border.inverse-secondary-disabled',
                _hover: {
                    bg: 'button.background.inverse-secondary-disabled',
                    color: 'button.text.inverse-secondary-disabled !important',
                    border: remCalc(2),
                    borderColor: 'button.border.inverse-secondary-disabled',
                },
            },
            _pressed: {
                border: remCalc(1),
                bg: 'button.background.inverse-secondary-pressed',
                color: 'button.text.inverse-secondary-pressed',
                borderColor: 'button.border.inverse-secondary-pressed',
                borderStyle: 'solid',
            },
        },
        'inverse-icon-button': {
            bg: 'button.background.inverse-icon-default',
            color: 'button.text.inverse-icon-default',
            _hover: {color: 'button.text.inverse-icon-hover'},
            _disabled: {
                color: 'button.text.inverse-icon-default',
                cursor: 'not-allowed',
                _hover: {
                    color: 'button.text.inverse-icon-default',
                    textDecoration: 'none',
                    cursor: 'not-allowed',
                },
            },
            _pressed: {color: 'button.text.inverse-icon-pressed'},
        },
        'inverse-text-button': {
            bg: 'button.background.inverse-text-default',
            color: 'button.text.inverse-text-default',
            textDecoration: 'underline',
            _disabled: {color: 'button.text.inverse-text-disabled'},
        },
        'inverted-pressed': {
            padding: `${remCalc(18)} ${remCalc(24)}`,
            maxHeight: remCalc(40),
            border: remCalc(2),
            borderStyle: 'solid',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            bg: 'button.background.secondary-pressed',
            color: 'button.text.secondary-pressed',
            borderColor: 'button.border.secondary-pressed',
        },
    },
    defaultProps: {variant: 'unstyled', colorScheme: 'unset', size: 'none'},
}
